import { render, staticRenderFns } from "./OrderDetail.vue?vue&type=template&id=e4187ee6&scoped=true"
import script from "./OrderDetail.vue?vue&type=script&lang=ts"
export * from "./OrderDetail.vue?vue&type=script&lang=ts"
import style0 from "./OrderDetail.vue?vue&type=style&index=0&id=e4187ee6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4187ee6",
  null
  
)

export default component.exports